import "../../components/App.css";
import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import { Alert, Spinner } from "react-bootstrap";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import countryToCurrency from "country-to-currency";
import axios from "axios";
import { API_BASE_URL } from "../../config/config";
import CaptchaField from "../../components/CaptchaField";
import { Link } from "react-router-dom";
import { jwtDecode } from 'jwt-decode';
import CarePlanPaymentHandler from "../../components/Payment/CarePlanPaymentHandler";

const ManufacturingCarePlan = ({ userDetails }) => {
  const [currencies, setCurrencies] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [selectedRegistrationDetails, setSelectedRegistrationDetails] =
    useState(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [recaptchaToken, setRecaptchatToken] = useState("");
  const [user, setUser] = useState(null);

  useEffect(() => {}, [selectedImages]);

  useEffect(() => {
    const currencies = Object.values(countryToCurrency);
    const currency = [...new Set(currencies)];
    setCurrencies(currency);
  }, []);

  useEffect(() => {
    const currencies = Object.values(countryToCurrency);
    const currency = [...new Set(currencies)];
    setCurrencies(currency);
  }, []);

  const handleImageChange = (event) => {
    const files = event.target.files;
    setSelectedImages([...files]);
  };

  const handleRegistrationDetailsChange = (event) => {
    const file = event.target.files[0];
    setSelectedRegistrationDetails(file);
  };

  const calculateCareValues = (values) => {
    let careFees = 0;
    const careAmount = parseFloat(values.careValueAmount);

    switch (values.category) {
      case "Warehouse":
        careFees = careAmount * 0.12;
        break;
      case "Retail":
        careFees = careAmount * 0.1;
        break;
      case "Logistics":
        careFees = careAmount * 0.1;
        break;
      default:
        break;
    }
    values.careFees = careFees.toFixed(2);
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const formData = new FormData();

      formData.append("email", userDetails.email)
      formData.append("password", userDetails.password)
      formData.append("fName", userDetails.fName)
      formData.append("mName", userDetails.mName)
      formData.append("lName", userDetails.lName)
      formData.append("country", userDetails.country)
      formData.append("state", userDetails.state)
      formData.append("city", userDetails.city)
      formData.append("zip", userDetails.zip)
      formData.append("contact", userDetails.contact)

      values.services.forEach((service, index) => {
        calculateCareValues(service);

        formData.append("registrationDetails", selectedRegistrationDetails);

        selectedImages.forEach((image) => {
          formData.append("establishmentPictures", image);
        });

        Object.entries(service).forEach(([key, value]) => {
          if (key !== "registrationDetails" && key !== "establishmentPictures") {
            formData.append(`services[${index}][${key}]`, value);
          }
        });
      });

      Object.keys(values).forEach((key) => {
        if (key !== "services") {
          formData.append(key, values[key]);
        }
      });

      formData.append("recaptchaToken", recaptchaToken);

      console.log(values);

      await axios.post(`${API_BASE_URL}/register`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const token = localStorage.getItem('care_token');
      const tokenData = jwtDecode(token);
      const userId = tokenData.userId;
      const response = await axios.get(`${API_BASE_URL}/user?userId=${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    setUser(response.data.user);

    } catch (error) {
      console.error("Error:", error.response?.data?.error || error.message);
      setError("Error submitting the form");
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  const handleCaptchaChange = (token) => {
    if (token) {
      setRecaptchatToken(token);
    }
  };

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={["DatePicker"]}>
          <Formik
            initialValues={{
              services: [
                {
                  type: "Manufacturing & Goods",
                  category: "",
              establishmentName: "",
              areaInSqft: "",
              registrationDetails: "",
              establishmentPictures: [],
              establishmentDetails: "",
              referralCode: "",
              currency: "",
              careFees: 0,
              careValueAmount: 0,
              careExpireTimeline: "1 Year",
                },
              ],
            }}
            onSubmit={handleSubmit}
          >
            {(formik) => (
              <Form>
                {formik.values.services.map((service, index) => (
                  <div key={index}>
                    <Grid container spacing={2} style={{ marginTop: 0 }}>
                   <Grid item xs={12} sm={6}>
                    <InputLabel htmlFor={`services[${index}].category`}>
                      Select Product Category
                    </InputLabel>
                    <Field
                      as={Select}
                      style={{ width: "100%" }}
                      size="small"
                      name={`services[${index}].category`}
                      id={`services[${index}].category`}
                    >
                      <MenuItem value="Warehouse">Warehouse</MenuItem>
                      <MenuItem value="Retail">Retail</MenuItem>
                      <MenuItem value="Logistics">Logistics</MenuItem>
                    </Field>
                    <ErrorMessage name={`services[${index}].category`} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputLabel
                      htmlFor={`services[${index}].establishmentName`}
                    >
                      Establishment Name
                    </InputLabel>
                    <Field
                      as={TextField}
                      style={{ width: "100%" }}
                      size="small"
                      name={`services[${index}].establishmentName`}
                      id={`services[${index}].establishmentName`}
                    />
                    <ErrorMessage name={`services[${index}].establishmentName`} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputLabel htmlFor={`services[${index}].currency`}>Select Currency</InputLabel>
                    <Field
                      as={Select}
                      style={{ width: "100%" }}
                      size="small"
                      name={`services[${index}].currency`}
                      id={`services[${index}].currency`}
                    >
                      <MenuItem value="">Select Currency</MenuItem>
                      {currencies.map((currency) => (
                        <MenuItem key={currency} value={currency}>
                          {currency}
                        </MenuItem>
                      ))}
                    </Field>
                    <ErrorMessage name={`services[${index}].currency`} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputLabel
                      htmlFor={`services[${index}].careValueAmount`}
                    >
                      Enter Care Amount
                    </InputLabel>
                    <Field
                      as={TextField}
                      style={{ width: "100%" }}
                      size="small"
                      name={`services[${index}].careValueAmount`}
                      id={`services[${index}].careValueAmount`}
                    />
                    <ErrorMessage name={`services[${index}].careValueAmount`} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputLabel htmlFor={`services[${index}].areaInSqft`}>
                      Area in Sqft
                    </InputLabel>
                    <Field
                      as={TextField}
                      style={{ width: "100%" }}
                      size="small"
                      name={`services[${index}].areaInSqft`}
                      id={`services[${index}].areaInSqft`}
                    />
                    <ErrorMessage name={`services[${index}].areaInSqft`} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputLabel
                      htmlFor={`services[${index}].establishmentDetails`}
                    >
                      Brief Details about Establishment
                    </InputLabel>
                    <Field
                      as={TextField}
                      style={{ width: "100%" }}
                      size="small"
                      name={`services[${index}].establishmentDetails`}
                      id={`services[${index}].establishmentDetails`}
                    />
                    <ErrorMessage name={`services[${index}].establishmentDetails`} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputLabel
                      htmlFor={`services[${index}].registrationDetails`}
                    >
                      Registration Details Upload
                    </InputLabel>
                    <input
                      style={{ width: "100%" }}
                      size="small"
                      type="file"
                      name={`services[${index}].registrationDetails`}
                      id={`services[${index}].registrationDetails`}
                      onChange={handleRegistrationDetailsChange}
                      required
                    />
                    <ErrorMessage name={`services[${index}].registrationDetails`} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputLabel
                      htmlFor={`services[${index}].establishmentPictures`}
                    >
                      Establishment Pictures Upload (4)
                    </InputLabel>
                    <input
                      style={{ width: "100%" }}
                      size="small"
                      type="file"
                      name={`services[${index}].establishmentPictures`}
                      id={`services[${index}].establishmentPictures`}
                      onChange={handleImageChange}
                      multiple
                      required
                    />
                    <ErrorMessage name={`services[${index}].establishmentPictures`} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputLabel htmlFor={`services[${index}].referralCode`}>
                      Referral Code (If Any)
                    </InputLabel>
                    <Field
                      as={TextField}
                      style={{ width: "100%" }}
                      size="small"
                      name={`services[${index}].referralCode`}
                      id={`services[${index}].referralCode`}
                    />
                    <ErrorMessage name={`services[${index}].referralCode`} />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <InputLabel
                      htmlFor={`services[${index}].careFees`}
                      align="center"
                    >
                      Care Fees to Pay
                    </InputLabel>
                    <Typography variant="h6" align="center" name={`services[${index}].careFees`}>
                      {service.category === "Warehouse" &&
                        service.careValueAmount &&
                        `${service.careValueAmount * 0.12} ${" "} ${
                          service.currency
                        }`}
                      {service.category === "Retail" &&
                        service.careValueAmount &&
                        `${service.careValueAmount * 0.1} ${" "} ${
                          service.currency
                        }`}
                      {service.category === "Logistics" &&
                        service.careValueAmount &&
                        `${service.careValueAmount * 0.1} ${" "} ${
                          service.currency
                        }`}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <InputLabel
                      htmlFor={`services[${index}].careValueAmount`}
                      align="center"
                    >
                      Your Care Value for 1st Year will be
                    </InputLabel>
                    <Typography
                      variant="body1"
                      align="center"
                      name={`services[${index}].careValueAmount`}
                    >
                      {service.careValueAmount} {service.currency}
                    </Typography>
                  </Grid>
                  </Grid>
                  </div>
                  ))}
                  <CaptchaField
                  onChange={handleCaptchaChange}
                  wrapperStyle={{ display: "flex" }}
                  style={{
                    margin: "0 auto",
                    textAlign: "center",
                    marginTop: "2rem",
                  }}
                />
                <div className="submission-popup">
                  <div className="loading">
                    {loading && <Spinner animation="border" />}
                  </div>
                  {error && <Alert variant="danger">{error}</Alert>}
                  {success && (
                    <Alert variant="success">
                      Form submitted successfully!
                    </Alert>
                  )}
                </div>
                <Grid container spacing={2} justifyContent="center">
                  <Button
                    type="submit"
                    variant="contained"
                    color="success"
                    disabled={loading}
                    style={{ margin: "0.5rem" }}
                  >
                    Submit & Pay
                  </Button>
                </Grid>
              </Form>
            )}
          </Formik>
        </DemoContainer>
      </LocalizationProvider>
      <CarePlanPaymentHandler user={user} userDetails={userDetails} />
      <div style={{ marginTop: "1rem", textAlign: "center" }}>
        <Typography variant="body1">
          Already a user? <Link to="/login">Login</Link>
        </Typography>
      </div>
    </div>
  );
};

export default ManufacturingCarePlan;
